import type { RouteObject } from 'react-router-dom'

const leaveRoute: RouteObject = {
  children: [
    {
      path: 'leave-policy',
      children: [
        { lazy: () => import('@/pages/leave/leave-policy/index/page'), path: '' },
        { lazy: () => import('@/pages/leave/leave-policy/create/page'), path: 'create' },
        { lazy: () => import('@/pages/leave/leave-policy/edit/page'), path: ':leavePolicyId/edit' },
      ],
    },
    {
      path: 'leave-quota',
      children: [
        {
          lazy: () => import('@/pages/leave/leave-quota/index/page'),
          path: '',
        },
      ],
    },
    { lazy: () => import('@/pages/leave/leave-management/index/page'), path: 'leave-management' },
  ],

  path: 'leave',
}

export default leaveRoute
